import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from '../../../../adapter-vue';
import { TUITranslateService, IMessageModel } from '@tencentcloud/chat-uikit-engine';
import Icon from '../../../common/Icon.vue';
import files from '../../../../assets/icon/file-light.svg';
import type { IFileMessageContent } from '../../../../interface';


export default /*#__PURE__*/_defineComponent({
  __name: 'message-file',
  props: {
    content: { default: () => ({} as IFileMessageContent) },
    messageItem: { default: () => ({} as IMessageModel) }
  },
  setup(__props: any) {

const props = __props as { content: IFileMessageContent, messageItem: IMessageModel }



const download = (url) => {
  if (props.messageItem.hasRiskContent) {
    return;
  }
  window.open(url)
  // const option = {
  //   mode: 'cors',
  //   headers: new Headers({
  //     'Content-Type': 'application/x-www-form-urlencoded',
  //   }),
  // } as RequestInit;
  // // If the browser supports fetch, use blob to download, so as to avoid the browser clicking the a tag and jumping to the preview of the new page
  // if ((window as any)?.fetch) {
  //   fetch(props.content.url, option)
  //     .then(res => res.blob())
  //     .then((blob) => {
  //       const a = document.createElement('a');
  //       const url = window.URL.createObjectURL(blob);
  //       a.href = url;
  //       a.download = props.content.name;
  //       a.click();
  //     });
  // } else {
  //   const a = document.createElement('a');
  //   a.href = props.content.url;
  //   a.target = '_blank';
  //   a.download = props.content.name;
  //   a.click();
  // }
};

return { __sfc: true,props, download, TUITranslateService }
}

})